<template>
  <div class="my-dashboard d-print-none ">


    <div class="row align-items-center img-background-card py-5 dash-rounded-normal border shadow ">
      <div class="col-lg-3 col-6 text-center ">
        <img src="../../../../public/profile.webp" class="col-6 img-fluid"
             v-if="$store.getters['User/getProfile'].image == null"></img>
        <img v-else class="img-fluid h1  shadow rounded text-center rounded-circle profile-image"
             :src="$store.getters['User/getProfile'].image" alt="profile">
        <div class="d-print-none mt-1 text-white"> {{
            `${$store.getters['User/getProfile'].name} ${$store.getters['User/getProfile'].last_name}`
          }}
          <div class="col-12 text-white"> خوش آمدید !</div>
        </div>
      </div>


      <span class="col-lg-3 col-6 my-2 text-center ">
               <img class="img-fluid my-2 col-6" src="../../../../public/coin.webp">
               <widget-wallet/>
      </span>

      <span class="col-lg-3 col-6 my-2 text-center ">
               <img class="img-fluid my-2 col-6" src="../../../../public/adress.webp">
                  <div class="col-12">
                     <router-link :to="{name: 'Address'}">
                          <b-btn size="sm" class="align-items-baseline" pill>
                             آدرس های من
                          </b-btn>
                     </router-link>
                  </div>
      </span>


      <span class="col-lg-3 col-6 my-2 text-center ">
               <img class="img-fluid my-2 col-6" src="../../../../public/form.webp">
                  <div class="col-12">
                    <router-link :to="{name: 'CurrentUserFormFills'}">
                    <b-btn size="sm" class="align-items-baseline" pill>
                      فرم های من
                     </b-btn>
                  </router-link>
                </div>
      </span>
    </div>


  </div>
</template>

<script>
import WidgetWallet from "../../components/dashboard/Wallet/WidgetWallet";

export default {
  name: "DashboardMobileProfile",
  components: {WidgetWallet},
}
</script>

<style scoped>
.profile-image {
  height: 60px;
  width: 75px;
  object-fit: contain;
}

.img-background-card {
  background-image: url("../../../../public/patern.png") !important;
  background: var(--primary);
}
</style>